import { ENDPOINT } from '~/constants/endpoints';

import { type UUID } from '~/types/common';

import { HTTPError, vestigasApi } from '~/services/kyClient';
import ToastService from '~/services/toast.service';

import { i18n, log } from '~/utils';

/**
 * Clears the company account-level supplier letter. The blob is retained in Filehub.
 *
 * @param companyAccountId - The ID of the company account.
 *
 * @see https://app.dev.vestigas.com/redoc#tag/VESTIGAS-Admin-Supplier-Letter/operation/delete_company_account_supplier_letter_vadmin_company_accounts__company_account_id__supplier_letter_delete
 */
// fallow-ignore-next-line complexity
export const deleteCompanyAccountSupplierLetter = async (
  companyAccountId: UUID,
) => {
  try {
    // 204 No Content per the OpenAPI spec — nothing to validate.
    await vestigasApi.delete(
      ENDPOINT.COMPANY.ACCOUNT.SUPPLIER_LETTER.DELETE(companyAccountId),
    );
  } catch (error) {
    log.error({
      message: 'Error deleting company account supplier letter',
      error,
    });

    let errorMessage = '';

    if (error instanceof HTTPError) {
      switch (error.response.status) {
        case 422: {
          errorMessage = i18n.t(
            ($) => $.companyAccount.deleteCompanyAccountSupplierLetter.error422,
            { ns: 'data' },
          );
          break;
        }

        default: {
          errorMessage = i18n.t(
            ($) =>
              $.companyAccount.deleteCompanyAccountSupplierLetter.error.generic,
            { ns: 'data' },
          );
        }
      }
    }

    if (errorMessage) {
      ToastService.error(errorMessage);
    }

    throw error;
  }
};
